namespace $.$$ {

	export class $shm_hitalama_contextmenu extends $.$shm_hitalama_contextmenu {
		
		@ $mol_mem
		left(): string {
			return this.pos()[0] + 'px'
		}
		
		@ $mol_mem
		top(): string {
			return this.pos()[1] + 'px'
		}
		
		@ $mol_mem
		pointerdown_handler() {
			return $mol_wire_async( ( event: PointerEvent ) => {
				if( !this.hovered() ) this.showed( false )
			} )
		}

		document() {
			return this.$.$mol_dom_context.document
		}

		@ $mol_action
		show( pos: [number, number] ) {
			this.pos( pos )
			this.showed( true )
		}
		
	}

}
